export const update = {
  updateSuccessfully: 'Update uniform successfully!',
}
